import aiModelTrainingIcon from '../../../public/svg/icons/synthetic-data/ai-model-training.svg';
import analyticsAndBIIcon from '../../../public/svg/icons/synthetic-data/analytics-and-bi.svg';
import demosAndPrototypesIcon from '../../../public/svg/icons/synthetic-data/demos-and-prototypes.svg';
import developmentAndTestingIcon from '../../../public/svg/icons/synthetic-data/development-and-testing.svg';
import governanceAndFairnessIcon from '../../../public/svg/icons/synthetic-data/governance-and-fairness.svg';
import type { UseCaseData } from './UseCases.types';

export const useCasesData = {
  title: 'What is Synthetic Data Used For?',
  subTitle: `Synthetic data solves the critical challenge of needing realistic, diverse data when real info is unavailable, too expensive to collect, locked behind privacy restrictions, or simply doesn't exist yet for new products. It can be used in various ways and in multiple industries, even in gaming!`,
  items: [
    {
      title: 'Development & Testing',
      description:
        'Forget waiting weeks for sanitized production data. Spin up realistic datasets instantly and let your team ship faster without the compliance headaches.',
      icon: developmentAndTestingIcon,
    },
    {
      title: 'AI Model Training',
      description:
        'Train your ML models on data that looks, acts, and performs like the real thing—minus the privacy nightmares and regulatory red tape.',
      icon: aiModelTrainingIcon,
    },
    {
      title: 'Analytics & BI',
      description:
        'Unlock insights without the endless approval chains. Give your analysts the data playground they need to explore, experiment, and do their jobs right.',
      icon: analyticsAndBIIcon,
    },
    {
      title: 'Demos & Prototypes',
      description: `Show off your product with confidence. Build impressive demos using realistic data that won't get your legal team's phone ringing.`,
      icon: demosAndPrototypesIcon,
    },
    {
      title: 'Governance & Fairness',
      description:
        'Stress-test your models with edge cases and diverse scenarios that real data rarely provides. Build solutions that are not just smart, but responsible.',
      icon: governanceAndFairnessIcon,
    },
  ] satisfies UseCaseData[],
};
